import { ChevronLeft } from '@mui/icons-material';
import { IconButton } from '@mui/material';

const DashboardButton = ({ menuOpen, onToggle }) => {
  return (
    <IconButton
      id="btn-dash"
      aria-haspopup="true"
      aria-expanded={menuOpen}
      aria-label={menuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
      onClick={onToggle}
      sx={{
        position: 'fixed',
        top: '10%',
        right: 0,
        width: 84,
        height: 56,
        fontSize: 12,
        fontWeight: 700,
        backgroundColor: 'rgba(255,255,255,0.98)',
        color: '#134491',
        borderRadius: '20px 0 0 20px',
        boxShadow: '-4px 4px 20px rgba(23, 55, 141, 0.4)',
        zIndex: 1001,
        transition: 'background-color 0.2s, box-shadow 0.2s, color 0.2s',
        '& svg': {
          transition: 'transform 0.25s ease',
          transform: menuOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        },
        '&:hover': {
          backgroundColor: 'rgba(255,255,255,1)',
          color: '#0f2868',
          boxShadow: '-6px 0 24px rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      <ChevronLeft sx={{ fontSize: 28 }} />
      <span>MENU</span>
    </IconButton>
  );
};

export default DashboardButton;
